import { styles } from '../../styles/styles.util';

export const ViewWrapper = ({ children }) => {
  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>{children}</div>
    </div>
  );
};
